import React from 'react';
import { useLocation } from 'react-router-dom';
import TopNav from './TopNav';
import SideNav from './SideNav';
import Intro from './Intro';
import Elevator from './Elevator';

/**
 * Header Component
 * 
 * Exactly matches the legacy site's header structure.
 * Shows the Intro component (with "marc.tools") on every page.
 * Only shows the Elevator component (with "Product R&D Toolkit") on the homepage.
 */
const Header = () => {
  const location = useLocation();
  const isHomepage = location.pathname === '/';
  
  return (
    <header>
      <SideNav />
      <TopNav />
      <Intro />
      {isHomepage && <Elevator />}
    </header>
  );
};

export default Header; 